import { Button, assets } from '@round/whitelabel-ui';
import { ReactNode } from 'react';
import styles from './BackupCreatorsExpandableBar.module.css';
import cn from 'classnames';

const { ChevronRight: ChevronIcon } = assets;

type Props = {
    isExpanded: boolean;
    onExpandToggle: () => void;
    backupCreatorsCount?: number;
    children?: ReactNode;
};

const BackupCreatorsExpandableBar = ({ isExpanded, onExpandToggle, backupCreatorsCount, children }: Props) => {
    return (
        <>
            <div className={styles.container}>
                <Button
                    className={cn(styles.expandButton, { [styles.expanded]: isExpanded })}
                    appearance="ghost"
                    onClick={onExpandToggle}
                >
                    <ChevronIcon className={styles.expandButtonIcon} />
                </Button>

                <span>
                    {backupCreatorsCount} backup creator{backupCreatorsCount !== 1 ? 's' : ''}
                </span>
            </div>

            {isExpanded && children}
        </>
    );
};

export default BackupCreatorsExpandableBar;
